<script setup>
  import {computed, inject} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import {recordOriginIcons, recordOriginTexts} from "@pages/Records/Enums/Enums.js";

  defineOptions({name: "ComponentRowOriginFromMergeBadge"});

  const props = defineProps({
    type: {
      type: String,
      required: true,
    },
    hashid: {
      type: [String, null],
      default: null,
    },
  });

  const getRowOriginFromMergeLog = inject("getRowOriginFromMergeLog");

  const origin = computed(() => {
    if (!props.hashid) {
      return {
        show: false,
      };
    }

    const data = getRowOriginFromMergeLog(props.type, props.hashid);

    return {
      show: data && data?.record_id,
      origin: data?.origin ?? null,
      name: data?.origin ? recordOriginTexts[data.origin] : "manuelle Eingabe",
      icon: data?.origin ? recordOriginIcons[data.origin] : "edit",
      recordLabel: data?.label ?? null,
      createdAt: data?.created_at ?? null,
    };
  });
</script>

<template>
  <div>
    <div
      v-if="origin.show || $slots.default"
      class="inline-flex items-center divide-x-2 divide-mcblue-400 rounded-md bg-mcblue-100 p-1 text-xs font-medium text-mcblue [&>span]:px-1"
    >
      <slot>
        <span v-if="origin.icon || origin.name" class="inline-flex items-center gap-x-1.5">
          <ComponentIcon v-if="origin.icon">{{ origin.icon }}</ComponentIcon>
          Herkunft: {{ origin.name }}
        </span>

        <span v-if="origin.recordLabel">{{ origin.recordLabel }}</span>
        <span v-if="origin.createdAt">{{ origin.createdAt }}</span>
      </slot>
    </div>
  </div>
</template>
